import type { SystemStyleObject } from "@ecco/ui/theme-tools";

export const styles: { [key: string]: SystemStyleObject } = {
    section: {
        px: [3, 4, 6],
        pt: 6,
        pb: 12,
        bg: "white",
    },
    title: {
        fontSize: ["mobileHeadline5", "desktopHeadline5"],
        fontWeight: "bold",
        textTransform: "uppercase",
        letterSpacing: "0.4px",
    },
};
